"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKStepper = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
var React = __importStar(require("react"));
var components_1 = require("../../components");
var common_1 = require("../../common");
require("./GKStepper.css");
var GKStepper = function (props) {
    var _a = (0, common_1.useMergedProps)(props, { _gkComponentIdentifier: "gk-stepper" }), id = _a.id, qa = _a["data-qa"], disabled = _a.disabled, invalid = _a.invalid, max = _a.max, min = _a.min, onChange = _a.onChange, positiveIndicator = _a.positiveIndicator, _b = _a.step, step = _b === void 0 ? 1 : _b, suffix = _a.suffix, valid = _a.valid, _c = _a.value, value = _c === void 0 ? 0 : _c, passthroughProps = __rest(_a, ["id", "data-qa", "disabled", "invalid", "max", "min", "onChange", "positiveIndicator", "step", "suffix", "valid", "value"]);
    var inputProps = {
        disabled: disabled,
        invalid: invalid,
        max: max,
        min: min,
        step: step,
        valid: valid,
    };
    // IDs
    var uniqueID = (0, common_1.usePersistentId2)(id);
    var inputID = uniqueID + "--input";
    // State
    // const [value, setValue] = React.useState<number>(propValue);
    var _d = React.useState(), width = _d[0], setWidth = _d[1];
    // Ref to the span used to determine the width of the GKInput's content.
    var textSizeRef = React.useRef(null);
    var handleChange = function (e) {
        handleSetValue(parseFloat(e.currentTarget.value));
    };
    // Helper function to ensure values remain within the min/max bounds.
    var handleSetValue = function (val) {
        if (min !== undefined) {
            val = Math.max(min, val);
        }
        if (max !== undefined) {
            val = Math.min(max, val);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
    };
    // Focus the input if the prepended/appended text is clicked.
    // (because the actual input is quite small)
    var focusInput = function () { var _a; return (_a = document.getElementById(inputID)) === null || _a === void 0 ? void 0 : _a.focus(); };
    // Determine the width of the value. Used to resize the input.
    React.useEffect(function () {
        var _a;
        setWidth((_a = textSizeRef === null || textSizeRef === void 0 ? void 0 : textSizeRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
    }, [value]);
    return (React.createElement(components_1.GKInputGroup, __assign({}, passthroughProps, { id: uniqueID, "data-qa": qa }),
        React.createElement("span", { ref: textSizeRef, className: "position-absolute invisible", style: { pointerEvents: "none" } }, value),
        React.createElement(components_1.GKInputGroupAddon, { addonType: "prepend" },
            React.createElement(components_1.GKButton, { onClick: function () { return handleSetValue(value - step); }, disabled: (min !== undefined && value <= min) || disabled, "data-qa": qa + "--decrement" },
                React.createElement(components_1.GKIcon, { name: components_1.GKIconName.Remove }))),
        React.createElement(components_1.GKInputGroupAddon, { addonType: "prepend", className: "flex-grow-1 justify-content-end", onClick: focusInput }, value > 0 && (min !== null && min !== void 0 ? min : -1) < 0 && positiveIndicator ? "+" : " "),
        React.createElement(components_1.GKInput, __assign({ type: "number", value: value, onChange: handleChange, "data-qa": qa + "--input", id: inputID, className: "px-0 flex-grow-0", style: { minWidth: width, width: width, flexBasis: width } }, inputProps)),
        React.createElement(components_1.GKInputGroupAddon, { addonType: "append", className: "flex-grow-1 pl-1", onClick: focusInput }, suffix),
        React.createElement(components_1.GKInputGroupAddon, { addonType: "append" },
            React.createElement(components_1.GKButton, { onClick: function () { return handleSetValue(value + step); }, disabled: (max !== undefined && value >= max) || disabled, "data-qa": qa + "--increment" },
                React.createElement(components_1.GKIcon, { name: components_1.GKIconName.Add })))));
};
exports.GKStepper = GKStepper;
exports.default = exports.GKStepper;
